import { useSyncExternalStore } from "react";
import api from "./api";
import { uploadFile } from "./upload";

// Upload queue lives outside React so uploads keep running when the DJ navigates away and the real state is shown on return.
let items = [];
const listeners = new Set();
const emit = () => { items = [...items]; listeners.forEach((l) => l()); };

export const uploadStore = {
  subscribe(l) { listeners.add(l); return () => listeners.delete(l); },
  get() { return items; },
  add(list, kind) { items.push(...[...list].map((file) => ({ id: `${Date.now()}_${Math.random().toString(36).slice(2)}`, kind, file, title: file.name.replace(/\.[^.]+$/, ""), genres: "", description: "", progress: 0, status: "QUEUED", error: null, result: null }))); emit(); },
  update(id, p) { items = items.map((x) => (x.id === id ? { ...x, ...p } : x)); listeners.forEach((l) => l()); },
  remove(id) { items = items.filter((x) => x.id !== id); listeners.forEach((l) => l()); },
  clear(kind) { items = items.filter((x) => x.kind !== kind || x.status === "UPLOADING"); listeners.forEach((l) => l()); },
  async run(id, onDone) {
    const it = items.find((x) => x.id === id);
    if (!it) return;
    uploadStore.update(id, { status: "UPLOADING", error: null });
    try {
      const up = await uploadFile(it.file, "media", (p) => uploadStore.update(id, { progress: p }));
      uploadStore.update(id, { status: "PROCESSING" });
      const cur = items.find((x) => x.id === id) || it;
      const { data } = await api.post("/dj/recordings", { title: cur.title, submission_type: "upload", genres: cur.genres.split(",").map((x) => x.trim()).filter(Boolean), description: cur.description, media_url: up.url, media_file_id: up.file_id, as_draft: false, is_premium: false });
      uploadStore.update(id, { status: "SUBMITTED", progress: 100, result: data });
      onDone?.(data);
    } catch (e) { uploadStore.update(id, { status: "FAILED", error: e.response?.data?.detail || e.message }); }
  },
};

export function useUploadQueue() {
  return useSyncExternalStore(uploadStore.subscribe, uploadStore.get, uploadStore.get);
}
